"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_BROWSER = void 0;
exports.IS_BROWSER = typeof window !== "undefined";
//# sourceMappingURL=platform.js.map